export default ({ title, onClose, icon = null }) => {
  return (
    <div className="popup-calendario">
      <div className="popup-calendar-header">
        <div className="popup-calendar-title">
          {icon ? (
            <img className="popup-calendar-title-icon" src={icon} alt="" />
          ) : null}
          {title}
        </div>
        <img
          src="/images/close-white.svg"
          loading="lazy"
          alt=""
          className="popup-calendar-close"
          onClick={onClose}
        />
      </div>
    </div>
  );
};
